import React from "react";
import { useTranslation } from "react-i18next";

import { useGetLocationData } from "~/hooks/locationData";
import { useSubdivisionDeleteMutation } from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

interface DeleteSubdivisionModalProps {
  isOpen: boolean;
  handleCloseModal: () => void;
  refetch: () => void;
}

export const DeleteSubdivisionModal = (props: DeleteSubdivisionModalProps) => {
  const { isOpen, handleCloseModal, refetch } = props;
  const { t } = useTranslation();
  const { currentId } = useGetLocationData();
  const { notifySuccess, notifyError } = useNotify();

  const [deleteMutation] = useSubdivisionDeleteMutation({
    onCompleted() {
      handleCloseModal();
      refetch();
      notifySuccess(t("common.removed_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  const deleteDivision = () => {
    deleteMutation({
      variables: {
        id: currentId,
      },
    });
  };

  return (
    <ConfirmModal
      open={isOpen}
      text={t("editorSubdivision.delete")}
      onConfirm={deleteDivision}
      onCancel={handleCloseModal}
      centered
    />
  );
};
